import SideContainer from '@/components/Shared/SideContainer.vue'
import listActionPlans from '@/components/ActionPlan/List.vue'
import formActionPlans from '@/components/ActionPlan/Form.vue'
import {
  ACTION_PLAN_EVENT_OPEN,
  ACTION_PLAN_EVENT_OPEN_FORM,
  TEMPLATES,
} from './Enum'

const props = {
  plan: {
    type: Object,
    required: false,
  },
}

export default {
  props,
  components: {
    listActionPlans,
    formActionPlans,
    SideContainer,
  },
  data() {
    return {
      rootElement: 'span',
      rootChild: [],
    }
  },
  render(createElement) {
    return createElement(
      this.rootElement,
      {
        ref: 'side',
        on: {
          close: () => {
            this.cleanChild()
          },
        },
      },
      this.rootChild
    )
  },
  updated() {
    this.openSide(this.$refs.side)
  },
  mounted() {
    this.$root.$on(ACTION_PLAN_EVENT_OPEN, this.open)
    this.$root.$on(ACTION_PLAN_EVENT_OPEN_FORM, this.open)
  },
  methods: {
    cleanChild() {
      this.rootChild = []
    },
    open(template) {
      if (this.templateExists(template)) {
        const templateConfig = this.getTemplateConfig(template)

        this.rootElement = SideContainer
        this.rootChild = [
          this.$createElement('section', [
            this.$createElement(template, templateConfig),
          ]),
        ]
      }
    },
    templateExists(template) {
      return Object.values(TEMPLATES).includes(template)
    },
    openSide(side) {
      if (side.isOpen || !side.open) return false
      side.open()
      return side
    },
    getTemplateConfig(templateEnum) {
      const configs = {
        [TEMPLATES.FORM_ACTION_PLANS]: {
          props: { dataPlan: this.plan },
          on: {
            close: () => {
              this.$refs.side.close()
              this.$emit('close')
            },
          },
        },
      }

      return configs[templateEnum] || {}
    },
  },
}
